import moment from 'moment/moment';

export default function (app) {
  app.controller('klCustomerCenterRatePlanAmendCtrl', [
    '$state',
    '$window',
    'klSubscriptionService',
    'klNotificationService',
    'klAccountService',
    function ($state, $window, SubscriptionService, NotificationService, AccountService) {
      this.isLoading = true;
      this.ratePlanCtrl = $state.params.ratePlanCtrl;
      this.subscription = this.ratePlanCtrl.subscription;
      this.ratePlan = this.ratePlanCtrl.ratePlan;
      this.newQty = this.ratePlanCtrl.displayedQuantity;
      this.originalQty = this.ratePlan.quantity;
      this.isQuantityIncreased = this.ratePlanCtrl.displayedQuantityIsHigh;
      this.isResellerSubscription = !(
        this.subscription.invoiceOwnerAccountId == AccountService.getAccount().id
      );

      this.newSubscription = JSON.parse(JSON.stringify(this.subscription));
      this.newSubscription.ratePlans.forEach((ratePlan) => {
        if (!!ratePlan.quantity && ratePlan.id == this.ratePlan.id) {
          ratePlan.quantity = this.newQty;
        }
      });

      const setPreviewNextPeriod = ({
        date,
        ratePlanName,
        newQuantity,
        billingPeriod,
        price,
        tax,
      }) => {
        this.subscriptionPreview = [
          {
            label: 'Starting from ' + moment(date).format('MMM Do YYYY'),
            subtitle: 'A change of the pricing policy may affect the total price listed below.',
            ratePlans: [
              {
                ratePlanName,
                quantity: newQuantity,
                prices: { [billingPeriod]: { price, tax } },
              },
            ],
          },
        ];
      };

      const setPreviewNow = (amount) => {
        this.invoiceAmount = amount;
        this.invoiceLabel = 'Due Today';
      };

      SubscriptionService.previewSeatUpgrade(this.subscription.subscriptionNumber, this.newQty)
        .then((response) => {
          if (!response.success) {
            throw Error(response.reasons);
          }

          const { ratePlanCharges, ratePlanName } = this.ratePlanCtrl.ratePlan;

          const [{ billingPeriod }] = ratePlanCharges;
          const { newQuantity, proRataPricing, yearlyPricing, nextTermDate } = response;

          this.newQty = newQuantity;

          if (proRataPricing) {
            setPreviewNow(proRataPricing.amountWithoutTax + proRataPricing.taxAmount);
          }
          setPreviewNextPeriod({
            date: nextTermDate,
            ratePlanName,
            newQuantity,
            billingPeriod,
            price: yearlyPricing.amountWithoutTax + yearlyPricing.taxAmount,
            tax: yearlyPricing.taxAmount,
          });

          this.isLoading = false;
          this.subscriptionPreviewPeriods = [billingPeriod];
        })
        .catch((e) => {
          console.error(e);
          NotificationService.putError(
            'auth',
            "Couldn't calculate the price of your Upgrade. Please contact support@enscape3d.com to resolve this issue.",
          );
          $state.go('subscription');
        });

      this.cancel = function () {
        $state.go('subscription');
      };

      this.confirm = function () {
        const { subscription, ratePlan } = this;

        const onComplete = () => {
          this.isLoading = true;
          SubscriptionService.amend(subscription.subscriptionNumber, this.newQty)
            .then((response) => {
              const data = response.data;

              if (!data) {
                return NotificationService.putError('', 'No payment status');
              }

              if (!data.success) {
                const hasReasons = Boolean(data.reasons);
                const isPaymentMethodError =
                  hasReasons &&
                  data.reasons.some(
                    (r) =>
                      r.match(/gatewayResponse/) ||
                      r.match('the payment method can not be external for this operation'),
                  );

                const message = !hasReasons
                  ? 'Payment failed'
                  : isPaymentMethodError
                  ? [
                      'Please add a valid electronic payment method to proceed with the purchase.',
                      '<br/>Payment methods can be added by navigating to <a href="/account#!/payment">Payment Methods</a>',
                      'in your profile.',
                    ].join(' ')
                  : data.reasons.join(' ');
                NotificationService.putError('', message, isPaymentMethodError ? 1000000000 : 5000);
                return;
              }
              $window.location.reload();
            })
            .catch((e) => {
              NotificationService.putError('', e);
            })
            .finally(() => {
              this.isLoading = false;
            });
        };

        if (this.ratePlanCtrl.displayedQuantityIsLow) {
          const subscriptionId = subscription.id;
          const params = Object.assign({}, $state.params, {
            onComplete,
            subscription,
            subscriptionId,
            ratePlan,
          });

          $state.go('subscription.churn-survey', params);
        } else {
          onComplete();
        }
      };

      this.getPriceForPeriod = function (prices, period) {
        if (!prices[period]) {
          return '-';
        }
        return prices[period].price;
      };
    },
  ]);
}
